import MenuCopyingContainer from './MenuCopying.container';
import MenuCopyingComponent from './MenuCopying.component';

export default MenuCopyingContainer(MenuCopyingComponent);
